// Utility functions for API Credential Details

export const formatApiKey = (apiKey) => {
  if (!apiKey) return '';
  return apiKey.length > 20
    ? `${apiKey.substring(0, 8)}...${apiKey.substring(apiKey.length - 8)}`
    : apiKey;
};

export const getStatusColor = (status) => {
  return status === 'active' ? 'success' : 'default';
};

export const getLivePeriodText = (credential) => {
  if (!credential) return '';

  switch (credential.live_period_type) {
    case 'forever':
      return 'Forever';
    case 'duration':
      return `${credential.live_duration_days} days`;
    case 'until_date':
      return `Until ${new Date(
        credential.live_until_date,
      ).toLocaleDateString()}`;
    default:
      return 'Unknown';
  }
};

export const isExpired = (credential) => {
  if (!credential) return false;

  if (credential.live_period_type === 'until_date') {
    return new Date(credential.live_until_date) < new Date();
  }

  if (credential.live_period_type === 'duration') {
    const createdDate = new Date(credential.created_at);
    const expiryDate = new Date(
      createdDate.getTime() +
        credential.live_duration_days * 24 * 60 * 60 * 1000,
    );
    return expiryDate < new Date();
  }

  return false;
};

export const createCSVContent = (validData, invalidData, date) => {
  console.log('🔍 createCSVContent called with:', { validData: validData?.length, invalidData: invalidData?.length, date });
  console.log('🔍 First valid record:', validData?.[0]);
  
  // Extract date part more reliably to avoid timezone issues
  const dateStr = date.includes('T') ? date.split('T')[0] : date;
  
  // Add UTF-8 BOM for proper Arabic/Unicode character display in Excel
  const UTF8_BOM = '\uFEFF';
  let csvContent = UTF8_BOM + `Data for ${dateStr}\n\n`;

  // Valid data section
  csvContent += `VALID DATA (${validData.length} records)\n`;
  // Use the same column order as the system's standard reports + Status column
  csvContent += `Full Name,Phone,Age,E-mail Address,Country,Marks,MPC_4,Data Source,Other Data,Integration Source,Status\n`;

  validData.forEach((record) => {
    // Format phone number properly (convert from scientific notation if needed)
    let phone = record.phone || '';
    if (phone && typeof phone === 'string' && phone.includes('E+')) {
      // Convert scientific notation to regular number
      phone = parseFloat(phone).toString();
    }
    
    // Determine status based on data_source or other indicators
    let status = 'success'; // Default to success for valid data
    if (record.data_source) {
      const statusMapping = {
        'bulk_success': 'success',
        'bulk_invalid': 'invalid',
        'bulk_duplicated_free': 'duplicated',
        'bulk_duplicated_sent': 'duplicated',
        'snapchat': 'success',
        'facebook': 'success',
        'tiktok': 'success',
        'youtube': 'success',
        'twitter': 'success',
        'instagram': 'success',
        'linkedin': 'success',
        'daily_report': 'success',
        '2': 'success', // API credential ID 2 - treat as success
        '1': 'success', // API credential ID 1 - treat as success
        '3': 'success'  // API credential ID 3 - treat as success
      };
      status = statusMapping[record.data_source] || 'success';
    } else if (record.data_source === null || record.data_source === '') {
      // If data_source is null or empty, check if it's a system file upload
      if (record.integration_source && record.integration_source !== 'null') {
        status = 'success';
      } else {
        status = 'success'; // Default to success for valid data without specific source
      }
    }
    
    csvContent += `"${(record.fullName || '').replace(/"/g, '""')}",`;
    csvContent += `"${phone.replace(/"/g, '""')}",`;
    csvContent += `"${(record.age || '').replace(/"/g, '""')}",`;
    csvContent += `"${(record.email || '').replace(/"/g, '""')}",`;
    csvContent += `"${(record.country || '').replace(/"/g, '""')}",`;
    csvContent += `"${(record.marks || '').replace(/"/g, '""')}",`;
    csvContent += `"${(record.MPC_4 || '').replace(/"/g, '""')}",`;
    csvContent += `"${(record.data_source || '').replace(/"/g, '""')}",`;
    csvContent += `"${JSON.stringify(record.other_data || {}).replace(/"/g, '""')}",`;
    csvContent += `"${(record.integration_source || '').replace(/"/g, '""')}",`;
    csvContent += `"${status}"\n`;
  });

  // Invalid data section
  csvContent += `\nINVALID DATA (${invalidData.length} records)\n`;
  csvContent += `ID,Error Message,Data Content,Created At,Status\n`;

  invalidData.forEach((record) => {
    csvContent += `${record.id || ''},`;
    csvContent += `"${(record.error_message || '').replace(/"/g, '""')}",`;
    csvContent += `"${(record.data_content || '').replace(/"/g, '""')}",`;
    csvContent += `"${record.created_at || ''}",`;
    csvContent += `"invalid"\n`;
  });

  console.log('🔍 Generated CSV content preview:', csvContent.substring(0, 500));
  return csvContent;
};
